import { createSlice } from "@reduxjs/toolkit";
import getDoctorDiscountApi from "@custom/rtk-apis/billing/doctorDiscount/getDoctorDiscount";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getDoctorDiscountSlice = createSlice({
  name: "getDoctorDiscountSlice",
  initialState,
  reducers: {
    cleargetDoctorDiscount: (state) => {
        state.status = "";
        state.result = null;
        state.msg = "";
        state.loading = false;
        state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDoctorDiscountApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getDoctorDiscountApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.msg = payload.msg;
      })
      .addCase(getDoctorDiscountApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getDoctorDiscountSlice.reducer;
export const { cleargetDoctorDiscount } = getDoctorDiscountSlice.actions;
